import { ExternalLink } from 'lucide-react'
import { formatDistanceToNow } from 'date-fns'
import { openExternalLink } from '@/lib/browser'
import type { FeedItem } from '@/hooks/useNewsFeed'

type Props = { item: Extract<FeedItem, { type: 'news' }> }

export function NewsCard({ item }: Props) {
  const onClick = () => openExternalLink(item.link)

  return (
    <article
      onClick={onClick}
      role="link"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') onClick()
      }}
      className="cursor-pointer rounded-xl border bg-card overflow-hidden hover:shadow-md transition-shadow"
    >
      {item.image_url && (
        <div className="aspect-video bg-muted">
          <img
            src={item.image_url}
            alt=""
            className="w-full h-full object-cover"
            onError={(e) => {
              ;(e.target as HTMLImageElement).style.display = 'none'
            }}
          />
        </div>
      )}
      <div className="p-4 space-y-2">
        <div className="flex items-center gap-2 text-xs">
          <span
            className="px-2 py-0.5 rounded-full text-white font-semibold"
            style={{ backgroundColor: item.source_brand_color ?? '#666' }}
          >
            {item.source_short_name ?? item.source_name}
          </span>
          <span className="text-muted-foreground ml-auto">
            {formatDistanceToNow(new Date(item.published_at), { addSuffix: true })}
          </span>
        </div>

        <h2 className="text-base font-semibold leading-tight line-clamp-2">{item.title}</h2>

        {item.summary && (
          <p className="text-sm text-muted-foreground line-clamp-3">{item.summary}</p>
        )}

        <div className="flex items-center text-xs text-primary pt-1">
          <span>Read on {item.source_name}</span>
          <ExternalLink className="h-3 w-3 ml-1" />
        </div>
      </div>
    </article>
  )
}
